var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './list.component.less';
import './list.carousel.component.less';
import { clone, cloneDeep, compact, extend, forEach, get, isArray, isEmpty, isEqual, isNil, isNumber, isString, union } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { element } from 'angular';
import 'angular-material';
import 'angular-sanitize';
import { Collection } from '@stratusjs/angularjs/services/collection';
import { isJSON, safeUniqueId } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
import '@stratusjs/angularjs-extras';
const min = !cookie('env') ? '.min' : '';
const packageName = 'idx';
const moduleName = 'property';
const componentName = 'list';
const localDir = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/src/${moduleName}/`;
const localDistStyle = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/dist/${packageName}.bundle.min.css`;
Stratus.Components.IdxPropertyList = {
    bindings: {
        elementId: '@',
        initNow: '=',
        tokenUrl: '@',
        googleApiKey: '@',
        detailsLinkPopup: '@',
        detailsLinkUrl: '@',
        detailsLinkTarget: '@',
        detailsHideVariables: '@',
        detailsTemplate: '@',
        advancedSearchUrl: '@',
        advancedSearchLinkName: '@',
        preferredStatus: '@',
        contactName: '@',
        contactEmail: '@',
        contactPhone: '@',
        template: '@',
        orderOptions: '@',
        displayOrderOptions: '@',
        urlLoad: '@',
        searchOnLoad: '@',
        query: '@',
        queryOrder: '@',
        queryPerPage: '@',
        queryService: '@',
        queryWhere: '@',
        hideDisclaimer: '@',
        displayPerRow: '@',
        displayPerRowText: '@',
        displayPager: '@',
    },
    controller($anchorScroll, $attrs, $q, $mdDialog, $scope, $timeout, $window, Idx) {
        $scope.localDir = localDir;
        $scope.initialized = false;
        if ($attrs.tokenUrl) {
            Idx.setTokenURL($attrs.tokenUrl);
            $scope.tokenLoaded = true;
        }
        let mlsVariables;
        let defaultQuery;
        let lastQuery;
        const init = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            var _d, _e, _f, _g, _h, _j, _k;
            $scope.uid = safeUniqueId(packageName, moduleName, componentName);
            $scope.elementId = $attrs.elementId || $scope.uid;
            Stratus.Instances[$scope.elementId] = $scope;
            $scope.instancePath = `Stratus.Instances.${$scope.elementId}`;
            if (!$scope.tokenLoaded && $attrs.tokenUrl) {
                Idx.setTokenURL($attrs.tokenUrl);
            }
            Stratus.Internals.CssLoader(localDistStyle).then();
            $scope.urlLoad = $attrs.urlLoad && isJSON($attrs.urlLoad) ? JSON.parse($attrs.urlLoad) : true;
            $scope.searchOnLoad = $attrs.searchOnLoad && isJSON($attrs.searchOnLoad) ? JSON.parse($attrs.searchOnLoad) : true;
            $scope.detailsLinkUrl = $attrs.detailsLinkUrl || '';
            $scope.detailsLinkTarget = $attrs.detailsLinkTarget || 'popup';
            $scope.detailsLinkPopup =
                $attrs.detailsLinkPopup && isJSON($attrs.detailsLinkPopup) ? JSON.parse($attrs.detailsLinkPopup) :
                    $scope.detailsLinkTarget === 'popup';
            $scope.detailsHideVariables = $attrs.detailsHideVariables && isJSON($attrs.detailsHideVariables) ?
                JSON.parse($attrs.detailsHideVariables) : [];
            $scope.detailsTemplate = $attrs.detailsTemplate || null;
            $scope.advancedSearchUrl = $attrs.advancedSearchUrl || '';
            $scope.advancedSearchLinkName = $attrs.advancedSearchLinkName || 'Advanced Search';
            $scope.preferredStatus = $attrs.preferredStatus || 'Closed';
            $scope.carouselOptions = $attrs.carouselOptions && isJSON($attrs.carouselOptions) ? JSON.parse($attrs.carouselOptions) : {};
            (_d = $scope.carouselOptions).autoplay || (_d.autoplay = false);
            (_e = $scope.carouselOptions).autoplayDelay || (_e.autoplayDelay = 3000);
            (_f = $scope.carouselOptions).transitionEffect || (_f.transitionEffect = 'fade');
            (_g = $scope.carouselOptions).speed || (_g.speed = 1000);
            (_h = $scope.carouselOptions).counter || (_h.counter = false);
            if (isString($scope.carouselOptions.counter)) {
                if ($scope.carouselOptions.counter === 'bullets') {
                    $scope.carouselOptions.counter = { render: 'bullets', clickable: true };
                }
                else if ($scope.carouselOptions.counter === 'numberBullet') {
                    $scope.carouselOptions.counter = { render: 'numberBullet', clickable: true };
                }
            }
            $scope.query = $attrs.query && isJSON($attrs.query) ? JSON.parse($attrs.query) : {};
            $scope.query.service = $attrs.queryService && isJSON($attrs.queryService) ?
                JSON.parse($attrs.queryService) : $scope.query.service || [];
            $scope.query.order =
                $scope.query.order && isString($scope.query.order) && isJSON($scope.query.order) ? JSON.parse($scope.query.order) :
                    $attrs.queryOrder && isJSON($attrs.queryOrder) ? JSON.parse($attrs.queryOrder) :
                        $attrs.queryOrder || $scope.query.order || null;
            (_j = $scope.query).page || (_j.page = null);
            $scope.query.perPage = $scope.query.perPage ||
                ($attrs.queryPerPage && isString($attrs.queryPerPage) ? parseInt($attrs.queryPerPage, 10) : null) ||
                ($attrs.queryPerPage && isNumber($attrs.queryPerPage) ? $attrs.queryPerPage : null) ||
                25;
            $scope.query.where = $attrs.queryWhere && isJSON($attrs.queryWhere) ? JSON.parse($attrs.queryWhere) : $scope.query.where || [];
            (_k = $scope.query).images || (_k.images = { limit: 1 });
            $scope.displayPerRow = 2;
            $scope.displayPerRowText = 'two';
            if ($attrs.displayPerRowText && isString($attrs.displayPerRowText)) {
                $scope.displayPerRowText = $attrs.displayPerRowText;
                $scope.displayPerRow = $scope.displayPerRowText === 'one' ? 1 : $scope.displayPerRowText === 'two' ? 2 :
                    $scope.displayPerRowText === 'three' ? 3 : $scope.displayPerRowText === 'four' ? 4 : 2;
            }
            else if ($attrs.displayPerRow && (isString($attrs.displayPerRow) || isNumber($attrs.displayPerRow))) {
                $scope.displayPerRow = isString($attrs.displayPerRow) ? parseInt($attrs.displayPerRow, 10) : $attrs.displayPerRow;
                $scope.displayPerRowText = $scope.displayPerRow === 1 ? 'one' : $scope.displayPerRow === 2 ? 'two' :
                    $scope.displayPerRow === 3 ? 'three' : $scope.displayPerRow === 4 ? 'four' : 'two';
            }
            $scope.displayOrderOptions = $attrs.displayOrderOptions && isJSON($attrs.displayOrderOptions) ?
                JSON.parse($attrs.displayOrderOptions) : true;
            $scope.displayPager =
                $attrs.displayPager ? (isJSON($attrs.displayPager) ? JSON.parse($attrs.displayPager) :
                    $attrs.displayPager) : true;
            $scope.hideDisclaimer = $attrs.hideDisclaimer && isJSON($attrs.hideDisclaimer) ?
                JSON.parse($attrs.hideDisclaimer) : false;
            if (isArray($scope.query.where)) {
                delete $scope.query.where;
            }
            const startingQuery = $scope.query.where || {};
            (_a = startingQuery.Status) !== null && _a !== void 0 ? _a : (startingQuery.Status = ['Active', 'Contract']);
            (_b = startingQuery.ListingType) !== null && _b !== void 0 ? _b : (startingQuery.ListingType = ['House', 'Condo']);
            $scope.query.where = extend(Idx.getDefaultWhereOptions(), startingQuery || {});
            defaultQuery = JSON.parse(JSON.stringify($scope.query.where));
            lastQuery = {};
            if ($scope.query.order) {
                defaultQuery.Order = $scope.query.order;
            }
            (_c = $scope.orderOptions) !== null && _c !== void 0 ? _c : ($scope.orderOptions = [
                { name: 'Highest Price', value: ['-BestPrice'] },
                { name: 'Lowest Price', value: ['BestPrice'] },
                { name: 'Recently Updated', value: ['-ModificationTimestamp'] },
                { name: 'Recently Sold', value: ['-CloseDate'] },
                { name: 'Status + Price', value: ['Status', '-BestPrice'] },
                { name: 'Status + Recent', value: ['Status', '-ModificationTimestamp'] }
            ]);
            $scope.googleApiKey = $attrs.googleApiKey || null;
            $scope.contactName = $attrs.contactName || null;
            $scope.contactEmail = $attrs.contactEmail || null;
            $scope.contactPhone = $attrs.contactPhone || null;
            $scope.mapMarkers = [];
            Idx.registerListInstance($scope.elementId, moduleName, $scope);
            let urlQuery = {
                Listing: {},
                Search: {}
            };
            if ($scope.urlLoad) {
                Idx.setUrlOptions('Search', JSON.parse(JSON.stringify(defaultQuery)));
                urlQuery = Idx.getOptionsFromUrl();
                if (urlQuery.hasOwnProperty('Listing') &&
                    urlQuery.Listing.hasOwnProperty('service') &&
                    urlQuery.Listing.ListingKey) {
                    $scope.displayModelDetails(urlQuery.Listing);
                }
                $scope.Idx.ensureItemsAreArrays($scope.query.where, [
                    'City',
                    'eCity',
                    'CountyOrParish',
                    'eCountyOrParish',
                    'MLSAreaMajor',
                    'eMLSAreaMajor',
                    'Neighborhood',
                    'eNeighborhood',
                    'PostalCode',
                    'OfficeNumber',
                    'AgentLicense',
                    'ListingId'
                ]);
            }
            if ($scope.searchOnLoad) {
                const searchQuery = {
                    where: clone(urlQuery.Search)
                };
                yield $scope.search(searchQuery, false, false);
            }
            $scope.$applyAsync(() => {
                $scope.initialized = true;
                Idx.emit('init', $scope);
            });
        });
        this.$onInit = () => {
            $scope.Idx = Idx;
            $scope.collection = new Collection({});
            let initNow = true;
            if (Object.prototype.hasOwnProperty.call($attrs.$attr, 'initNow')) {
                initNow = isJSON($attrs.initNow) ? JSON.parse($attrs.initNow) : false;
            }
            if (initNow) {
                init().then();
                return;
            }
            const stopWatchingInitNow = $scope.$watch('$ctrl.initNow', (initNowCtrl) => {
                if (initNowCtrl !== true) {
                    return;
                }
                if (!$scope.initialized) {
                    init().then();
                }
                stopWatchingInitNow();
            });
        };
        $scope.$watch('collection.models', () => {
            if ($scope.collection.completed) {
                Idx.emit('collectionUpdated', $scope, $scope.collection);
            }
        });
        $scope.getOtherPresetFilterCount = () => {
            const currentWhere = $scope.query.where;
            let filterCounts = compact(union(currentWhere.OfficeNumber, currentWhere.AgentLicense, currentWhere.ListingId)).length;
            if (currentWhere.OpenHouseOnly) {
                filterCounts++;
            }
            return filterCounts;
        };
        $scope.resetLocationQuery = () => {
            $scope.query.where.Location = '';
            $scope.query.where.eLocation = '';
            $scope.query.where.City = [];
            $scope.query.where.eCity = [];
            $scope.query.where.CountyOrParish = [];
            $scope.query.where.eCountyOrParish = [];
            $scope.query.where.MLSAreaMajor = [];
            $scope.query.where.eMLSAreaMajor = [];
            $scope.query.where.Neighborhood = [];
            $scope.query.where.eNeighborhood = [];
            $scope.query.where.PostalCode = [];
            $scope.query.where.ListingId = [];
            $scope.query.where.AgentLicense = [];
            $scope.query.where.OfficeNumber = [];
        };
        $scope.getPageModels = () => {
            const listings = [];
            const models = $scope.collection.models;
            models.slice(($scope.query.perPage * ($scope.query.page - 1)), ($scope.query.perPage * $scope.query.page)).forEach((listing) => {
                listings.push(listing);
            });
            return listings;
        };
        $scope.scrollToModel = (model) => {
            $anchorScroll(`${$scope.elementId}_${model._id}`);
        };
        $scope.hasQueryChanged = () => !isEqual(clone(lastQuery), clone($scope.query));
        $scope.search = $scope.searchProperties = (query, refresh, updateUrl) => __awaiter(this, void 0, void 0, function* () {
            return $q((resolve) => __awaiter(this, void 0, void 0, function* () {
                var _l;
                if ($scope.collection.pending) {
                    $scope.query = cloneDeep(lastQuery);
                    resolve([]);
                    return;
                }
                query !== null && query !== void 0 ? query : (query = clone($scope.query) || {});
                (_l = query.where) !== null && _l !== void 0 ? _l : (query.where = {});
                let urlWhere = clone(query.where) || {};
                updateUrl = updateUrl === false ? updateUrl : $scope.urlLoad === false ? $scope.urlLoad : true;
                if (Object.keys(query.where).length > 0) {
                    delete ($scope.query.where);
                    $scope.query.where = query.where;
                }
                else {
                    urlWhere = clone($scope.query.where) || {};
                }
                if (!isEmpty(query.where.Location) ||
                    !isEmpty(query.where.eLocation)) {
                    query.where.City = [];
                    query.where.eCity = [];
                    query.where.UnparsedAddress = '';
                    query.where.Neighborhood = [];
                    query.where.eNeighborhood = [];
                    query.where.CityRegion = [];
                    query.where.eCityRegion = [];
                    query.where.PostalCode = [];
                    query.where.MLSAreaMajor = [];
                    query.where.eMLSAreaMajor = [];
                    query.where.SubdivisionName = [];
                    query.where.eSubdivisionName = [];
                }
                if (query.where.page) {
                    query.page = query.where.page;
                    delete query.where.page;
                }
                if (query.where.Page) {
                    query.page = query.where.Page;
                    delete query.where.Page;
                }
                if (query.page) {
                    $scope.query.page = query.page;
                }
                if (refresh) {
                    $scope.query.page = 1;
                }
                if ($scope.query.page) {
                    urlWhere.Page = $scope.query.page;
                }
                if (urlWhere.Page <= 1) {
                    delete (urlWhere.Page);
                }
                if (query.where.order) {
                    query.order = query.where.order;
                    delete query.where.order;
                }
                if (query.where.Order) {
                    query.order = query.where.Order;
                    delete query.where.Order;
                }
                if (query.order) {
                    $scope.query.order = query.order;
                }
                if ($scope.query.order && $scope.query.order.length > 0) {
                    urlWhere.Order = $scope.query.order;
                }
                if (query.hasOwnProperty('service') &&
                    !isNil(query.service)) {
                    $scope.query.service = query.service;
                }
                if ($scope.hasQueryChanged()) {
                    Idx.setUrlOptions('Search', urlWhere);
                    if (updateUrl) {
                        Idx.refreshUrlOptions(defaultQuery);
                    }
                    Idx.emit('searching', $scope, clone($scope.query));
                    try {
                        const results = yield Idx.fetchProperties($scope.elementId, 'collection', $scope.query, refresh);
                        lastQuery = cloneDeep($scope.query);
                        Idx.emit('searched', $scope, clone($scope.query));
                        resolve(results);
                    }
                    catch (e) {
                        console.error('Unable to fetchProperties:', e);
                    }
                }
            }));
        });
        $scope.pageChange = (pageNumber, ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            Idx.emit('pageChanging', $scope, clone($scope.query.page));
            if (ev) {
                ev.preventDefault();
            }
            $scope.query.page = pageNumber;
            $anchorScroll($scope.elementId);
            yield $scope.search();
            Idx.emit('pageChanged', $scope, clone($scope.query.page));
        });
        $scope.pageNext = (ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            if (!$scope.query.page) {
                $scope.query.page = 1;
            }
            if ($scope.collection.completed && $scope.query.page < $scope.collection.meta.data.totalPages) {
                if (isString($scope.query.page)) {
                    $scope.query.page = parseInt($scope.query.page, 10);
                }
                yield $scope.pageChange($scope.query.page + 1, ev);
            }
        });
        $scope.pagePrevious = (ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            if (!$scope.query.page) {
                $scope.query.page = 1;
            }
            if ($scope.collection.completed && $scope.query.page > 1) {
                if (isString($scope.query.page)) {
                    $scope.query.page = parseInt($scope.query.page, 10);
                }
                const prev = $scope.query.page - 1 || 1;
                yield $scope.pageChange(prev, ev);
            }
        });
        $scope.orderChange = (order, ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            Idx.emit('orderChanging', $scope, clone(order));
            if (ev) {
                ev.preventDefault();
            }
            $scope.query.order = order;
            yield $scope.search(null, true, true);
            Idx.emit('orderChanged', $scope, clone(order));
        });
        $scope.getOrderOptions = () => {
            const options = {};
            $scope.orderOptions.forEach((orderOption) => {
                switch (orderOption.name) {
                    case 'Recently Sold': {
                        if ($scope.query.where.Status &&
                            $scope.query.where.Status.includes('Closed')) {
                            options[orderOption.name] = orderOption.value;
                        }
                        break;
                    }
                    case 'Status': {
                        if ($scope.query.where.Status &&
                            $scope.query.where.Status.length > 1) {
                            options[orderOption.name] = orderOption.value;
                        }
                        break;
                    }
                    default: {
                        options[orderOption.name] = orderOption.value;
                    }
                }
            });
            return options;
        };
        $scope.getOrderName = () => {
            let name;
            if ($scope.query.order !== '' &&
                !isEmpty($scope.query.order)) {
                for (const index in $scope.orderOptions) {
                    if ($scope.orderOptions.hasOwnProperty(index) &&
                        isEqual($scope.orderOptions[index].value, $scope.query.order)) {
                        name = $scope.orderOptions[index].name;
                        break;
                    }
                }
            }
            return name;
        };
        $scope.getDetailsURL = (property) => $scope.detailsLinkUrl + '#!/Listing/' + property._ServiceId + '/' + property.ListingKey + '/';
        $scope.getStreetAddress = (property) => $scope.Idx.getStreetAddress(property);
        $scope.getGoogleMapsKey = () => {
            return $scope.googleApiKey || Idx.getGoogleMapsKey();
        };
        $scope.getMLSVariables = (reset) => {
            if (!mlsVariables || Object.keys(mlsVariables).length === 0 || reset) {
                mlsVariables = {};
                let mlsServicesRequested = null;
                if ($scope.query &&
                    (isNumber($scope.query.service) ||
                        !isEmpty($scope.query.service))) {
                    if (!isArray($scope.query.service)) {
                        $scope.query.service = [$scope.query.service];
                    }
                    mlsServicesRequested = $scope.query.service;
                }
                Idx.getMLSVariables(mlsServicesRequested).forEach((service) => {
                    mlsVariables[service.id] = service;
                });
            }
            return Object.values(mlsVariables);
        };
        $scope.getMLSName = (serviceId) => {
            $scope.getMLSVariables();
            let name = 'MLS';
            if (mlsVariables[serviceId]) {
                name = mlsVariables[serviceId].name;
            }
            return name;
        };
        $scope.getMLSLogo = (serviceId, size = 'default') => {
            $scope.getMLSVariables();
            let logo;
            if (mlsVariables[serviceId]) {
                logo = get(mlsVariables[serviceId].logo, size) || get(mlsVariables[serviceId].logo, 'default');
            }
            return logo;
        };
        $scope.highlightModel = (model, timeout) => {
            var _a;
            timeout !== null && timeout !== void 0 ? timeout : (timeout = 0);
            (_a = model._unmapped) !== null && _a !== void 0 ? _a : (model._unmapped = {});
            $scope.$applyAsync(() => {
                model._unmapped._highlight = true;
            });
            if (timeout > 0) {
                $timeout(() => {
                    $scope.unhighlightModel(model);
                }, timeout);
            }
        };
        $scope.unhighlightModel = (model) => {
            var _a;
            if (model) {
                (_a = model._unmapped) !== null && _a !== void 0 ? _a : (model._unmapped = {});
                $scope.$applyAsync(() => {
                    model._unmapped._highlight = false;
                });
            }
        };
        $scope.displayModelDetails = (model, ev) => {
            if (ev) {
                ev.preventDefault();
            }
            if ($scope.detailsLinkPopup === true) {
                const templateOptions = {
                    'element-id': 'property_detail_popup_' + model.ListingKey,
                    service: model._ServiceId,
                    'listing-key': model.ListingKey,
                    'default-list-options': JSON.stringify(defaultQuery),
                    'page-title': true,
                    'url-load': $scope.urlLoad
                };
                if ($scope.getGoogleMapsKey()) {
                    templateOptions['google-api-key'] = $scope.getGoogleMapsKey();
                }
                if ($scope.contactName) {
                    templateOptions['contact-name'] = $scope.contactName;
                }
                if ($scope.contactEmail) {
                    templateOptions['contact-email'] = $scope.contactEmail;
                }
                if ($scope.contactPhone) {
                    templateOptions['contact-phone'] = $scope.contactPhone;
                }
                if ($scope.detailsHideVariables.length > 0) {
                    templateOptions['hide-variables'] = JSON.stringify($scope.detailsHideVariables);
                }
                if ($scope.preferredStatus) {
                    templateOptions['preferred-status'] = $scope.preferredStatus;
                }
                if ($scope.detailsTemplate) {
                    templateOptions.template = $scope.detailsTemplate;
                }
                let template = `<md-dialog class="stratus-idx-property-list-dialog" aria-label="${$scope.getStreetAddress(model)} Details">` +
                    `<div class="popup-close-button-container">` +
                    `<div aria-label="Close Popup" class="close-button" data-ng-click="closePopup()" aria-label="Close Details Popup"></div>` +
                    `</div>` +
                    '<stratus-idx-property-details ';
                forEach(templateOptions, (optionValue, optionKey) => {
                    template += `data-${optionKey}='${optionValue}'`;
                });
                template +=
                    '></stratus-idx-property-details>' +
                        '</md-dialog>';
                $mdDialog.show({
                    template,
                    parent: element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    scope: $scope,
                    preserveScope: true,
                    controller: ($scope, $mdDialog) => {
                        $scope.closePopup = () => {
                            if ($mdDialog) {
                                $mdDialog.hide();
                                Idx.setUrlOptions('Listing', {});
                                if ($scope.urlLoad) {
                                    Idx.refreshUrlOptions(defaultQuery);
                                }
                                Idx.setPageTitle();
                                $timeout(() => Idx.unregisterDetailsInstance('property_detail_popup', 'property'), 10);
                            }
                        };
                    }
                })
                    .then(() => {
                }, () => {
                    Idx.setUrlOptions('Listing', {});
                    if ($scope.urlLoad) {
                        Idx.refreshUrlOptions(defaultQuery);
                    }
                    Idx.setPageTitle();
                    $timeout(() => Idx.unregisterDetailsInstance('property_detail_popup', 'property'), 10);
                });
            }
            else {
                $window.open($scope.getDetailsURL(model), $scope.detailsLinkTarget);
            }
        };
        $scope.on = (emitterName, callback) => Idx.on($scope.elementId, emitterName, callback);
        $scope.remove = () => {
        };
    },
    templateUrl: ($attrs) => `${localDir}${$attrs.template || componentName}.component${min}.html`
};

//# sourceMappingURL=list.component.js.map
